import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Input } from 'antd'
import FormalityStepButton from '../FormalityStepButton'
import { FormInstance } from 'antd/es/form'

interface IProps {
  form: FormInstance
  onFinish: any
  loading?: boolean
}

const SubmissionFormConfirm = (props: IProps) => {
  const { t } = useTranslation('legalFormalities')
  const { form, onFinish, loading = false } = props
  const [formValid, setFormValid] = useState<boolean>(false)

  const validateFormFields = async () => {
    form
      .validateFields()
      .then(() => setFormValid(true))
      .catch(() => setFormValid(false))
  }

  const formItems = () => {
    return (
      <>
        {t('show.form.submission.title')}
        <Form.Item
          name="submissionId"
          label={t('show.form.submission.label')}
          rules={[
            { required: true },
            {
              pattern: /^[^-]+$/,
              message: t('show.form.submission.no_hyphen'),
            },
          ]}
        >
          <Input onChange={() => validateFormFields()} />
        </Form.Item>
      </>
    )
  }

  return (
    <>
      <FormalityStepButton
        title={t('show.form.submit.confirm.next.title')}
        description={formItems()}
        buttonDisabled={loading}
        buttonLabel={t('show.form.submit.confirm.next.label')}
        onConfirm={() => onFinish(form.getFieldsValue())}
        okConfirmDisabled={!formValid}
      />
    </>
  )
}

export default SubmissionFormConfirm
